import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold tracking-[0.01em] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-primary-200 bg-primary-50 text-primary-700 shadow-[0_6px_16px_-12px_rgba(8,122,88,.65)]",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "border-primary-300 text-primary-700 bg-primary-50",
        green: "border-primary-700 bg-primary-700 text-white shadow-[0_8px_18px_-12px_rgba(8,122,88,.8)]",
        "green-outline": "border-primary-200 text-primary-700 bg-primary-50 shadow-[0_6px_16px_-12px_rgba(8,122,88,.45)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
